import Vue from 'vue';
import Router from 'vue-router';
import qs from 'qs';
import { getUnionId, getBYDUnionId } from '@/api/api';
import { isWeiXin, isMobile } from '@/common/ts/common';
import SyActivityDemo from './views/samples';
import YSPXPC20260403 from '@/views/20260403YSPXPC';
import YSPXWAP20260403 from '@/views/20260403YSPXWAP';
import KLGXYLJH20260323 from '@/views/20260323KLGXYLJH';
import YQWQ20260604 from '@/views/20260604YQWQ';
import SQFLZCZN20260525 from '@/views/20260525SQFLZCZN';
import CQCC20260623 from '@/views/20260623CQCC';
import TYSY20260630 from '@/views/20260630TYSY';
import MMSJB20260609 from '@/views/20260609MMSJB';
import JJRW20260730 from '@/views/20260730JJRW';
import TYM20260811 from '@/views/20260811TYM';
import JQDM20260901 from '@/views/20260901JQDM';
import QNCQTDYDHG20260920 from '@/views/20260920QNCQTDYDHG';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import('@/views/HelloWorld.vue'),
    },
    // Demo展示
    SyActivityDemo,
    // 第11届渝商评选-报名表
    YSPXPC20260403,
    // 2026渝商评选
    YSPXWAP20260403,
    // 可灵高校原力计划互动抽奖
    KLGXYLJH20260323,
    // 以侨为桥
    YQWQ20260604,
    // 涉侨法律政策指南（2026年版）
    SQFLZCZN20260525,
    // 重庆市大学生创意传播作品大赛
    CQCC20260623,
    // 韵动巴渝·2026重庆体育影像比赛
    TYSY20260630,
    // 2026美加墨世界杯积分榜
    MMSJB20260609,
    // 2025十大重庆经济年度人物评选
    JJRW20260730,
    // “我的体育梦”征集活动
    TYM20260811,
    // 川渝景区住宿卫生全民点名季
    JQDM20260901,
    // 请你吃秋天的第一顿火锅
    QNCQTDYDHG20260920,
    {
      path: '*',
      name: 'not-found',
      component: () => import('@/views/NotFound/Home.vue'),
    },
    {
      path: '/code',
      name: 'code',
      component: () => import('@/components/next/MessageLogin.vue'),
    },
    {
      path: '/BindPhone',
      name: 'BindPhone',
      component: () => import('@/components/next/BindPhone.vue'),
    },
  ],
  // 跳转后回到顶部
  scrollBehavior(to, from, savedPosition): any {
    return (
      savedPosition || {
        x: 0,
        y: 0,
      }
    );
  },
});

router.beforeEach(async (to: any, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 以下操作均在微信环境中生效
  if (!isWeiXin()) {
    next();
    return;
  }
  const { code } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  // 控制微信授权是否启用
  if (to.meta.customWeChatAuth) {
    console.log('第三方公众号, 不默认拉取用户信息');
  } else if (code && !localStorage.getItem('unionid')) {
    console.log('request wx user info');
    let res: any = '';
    if (window.location.href.indexOf('BYD0621') > -1) {
      res = await getBYDUnionId({ code });
    } else {
      res = await getUnionId({ code });
    }
    if (res.code === 200) {
      console.log('res.data878738475o3874', res.data);
      window.localStorage.setItem('unionid', res.data.openId);
      window.localStorage.setItem('nickname', res.data.nickname);
      window.localStorage.setItem('headimgurl', res.data.headimgurl);
      // 应将用户微信信息整体存入localStorage
      localStorage.setItem('syWeChatUserInfo', JSON.stringify(res.data));
    } else {
      console.log('清理过期的code');
      // !query中清理过期code字段, 防止用户分享携带有自己的code的页面给其他人，导致无法进行授权登录的状况
      const queries = to.query;
      let strings = '';
      Object.keys(queries).forEach((item: any) => {
        if (item !== 'code') {
          strings += `${item}=${queries[item]}&`;
        }
      });
      strings = strings.slice(0, strings.length - 1);
      location.href = `${window.location.origin}${window.location.pathname}?${strings}`;
    }
  } else {
    console.log('例外');
  }
  next();
});

router.onError((error) => {
  // PC微信解析一个异步组件异常时错误收集
  if (isWeiXin() && !isMobile()) {
    const el = document.createElement('p');
    el.innerHTML = '请复制链接在Chrome, QQ, 360极速/安全等现代浏览器中打开';
    el.style.textAlign = 'center';
    document.body.innerHTML = '';
    document.body.appendChild(el);
  }
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = (router as Router & { history: any }).history.pending
    .fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
